import axios from 'axios';
import { FC, useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { URLS } from '../config';
import { items } from '../items';
import { custom } from '../custom';
import { PromocodeType } from '../types';
import { components } from '../components';
import { getDiscountList } from '../services/getDiscodListData';
import { hooks } from '../hooks'; // فرض بر اینکه اینجا useAppSelector هست

export const MyPromocodes: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [promocodesData, setPromocodesData] = useState<PromocodeType[]>([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const limit = 10;
  const token = hooks.useAppSelector(state => state.auth.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  
  const getPromocodes = useCallback(async (reset = false): Promise<void> => {
    if (!hasMore || loading) return;

    setLoading(true);
      const orderPayload = {
    limit,
    offset: reset ? 0 : offset,
  }
    const response = await getDiscountList(orderPayload, token, dispatch, navigate);

    if (Array.isArray(response.results)) {
      const newData = response.results;
      setPromocodesData(prev =>
        reset ? newData : [...prev, ...newData]
      );
      setOffset(prev => prev + newData.length);
      setHasMore(newData.length === limit);
    } else {
      setHasMore(false);
    }

    setLoading(false);
  }, [hasMore, loading, offset, token]);

  useEffect(() => {
    getPromocodes(true);
  }, []);

  const renderHeader = () => (
    <components.Header title='کدهای تخفیف من' goBack={true} />
  );

  const renderContent = (): JSX.Element => {
    if (loading && promocodesData.length === 0) {
      return <components.Loading />;
    }

    return (
      <div>
        <custom.InfiniteScrollR
          data={promocodesData}
          next={getPromocodes}
          hasMore={hasMore}
          loading={loading}
          endMessage="کدی باقی نمانده"
          style={{ paddingTop: 20, paddingBottom: 20 }}
        >
          {promocodesData.map(
            (item: PromocodeType, index: number, array: PromocodeType[]) => {
              const isLast = index === array.length - 1;
              return (
                <items.PromocodeItem key={index} item={item} isLast={isLast} />
              );
            }
          )}
          {/* <div
            style={{
              marginBottom: 40,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0 20px',
              marginTop: 30,
            }}
          >
            <custom.InputField
              label='کوپن را وارد کنید'
              containerStyle={{ width: 'calc(70% - 5px)' }}
              placeholder='کد تخفیف را اضافه کنید'
            />
            <components.Button
              title='اضافه کنید +'
              containerStyle={{ padding: 0, width: 'calc(30% - 5px)' }}
              onClick={() => {}}
            />
          </div> */}
        </custom.InfiniteScrollR>
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};